export default __webpack_public_path__ + "static/media/property_608.79c68442.png";